import { setPreference } from "components/Preferences/preferencesActions";
import React from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { PAGE_SIZE } from "redux/slices/api/initialisePreferences";

export const ReportsPerPageDropdown = () => {
  const dispatch = useDispatch();
  const pageSize = useSelector((state) => state.preferences[PAGE_SIZE][0]);
  const onChange = (ev) => {
    dispatch(setPreference({ key: PAGE_SIZE, value: ev.target.value }, true));
  };

  return (
    <Form.Control
      as="select"
      className="mb-1 mx-2 d-inline form-control-sm w-auto"
      value={pageSize}
      onChange={onChange}
    >
      {options}
    </Form.Control>
  );
};

const options = ["10", "20", "30", "40", "50"].map((option) => <option key={option}>{option}</option>);
